exports.getPrograms = async function (state) {
  return state.programsDB.get('programs')
}

// Returns a `{ programs: [...] }` doc-shaped object containing only the
// programs in `programIds`. Uses the `_design/programs-by-id` view so the
// browser only receives the user's tenant programs, instead of the full
// cross-tenant `programs` doc. Issue #22039.
exports.getProgramsByIds = async function (state, programIds) {
  if (!programIds || !programIds.length) {
    return { programs: [] }
  }

  const result = await state.programsDB.query('programs-by-id', {
    keys: programIds,
    include_docs: false
  })

  const programs = (result && result.rows ? result.rows : [])
    .filter(row => row && row.value)
    .map(row => row.value)

  return { programs }
}
